import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BaseModalComponent } from "@ha/ui/common";

import { FlammableMaterial } from "../../../models/customer-permit-template.model";

export interface FlammableMaterialInfoModalComponentData {
    material: FlammableMaterial;
}

@Component({
    selector: "pmt-flammable-material-info-modal",
    templateUrl: "./flammable-material-info-modal.component.html",
    styleUrls: ["./flammable-material-info-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlammableMaterialInfoModalComponent extends BaseModalComponent {
    public data!: FlammableMaterialInfoModalComponentData;

    public hasValue(value: string | number | null | undefined): boolean {
        if (value === null || value === undefined) {
            return false;
        }

        if (typeof value === "string") {
            return value.trim().length > 0;
        }

        return true;
    }

    public displayValue(value: string | number | null | undefined): string {
        if (value === null || value === undefined) {
            return "-";
        }

        if (typeof value === "string" && value.trim().length === 0) {
            return "-";
        }

        return value.toString();
    }
}
